import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CampaignId {

  private static id: any;

  public channel: Subject<any> = new Subject();

  setId(id) {
    CampaignId.id = id;
    this.channel.next(id);
  }

  getId() {
    return CampaignId.id;
  }

  release() {
    CampaignId.id = null;
    this.channel.next(null);
  }
}
